window.recentlyView = {

    recentlyViewed: [],
    currentVariant: null,
     currentProduct: null,
    currentProductHandle: null,
    currentVariantId: null,

    getRecentlyViewed() {
        let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
        var modalElementDefined = false;
        if (getRecentlyViewed != null) {
          getRecentlyViewed = JSON.parse(getRecentlyViewed);
          // Start code to remove current product from the recently viewed
          const index = getRecentlyViewed.findIndex((x) => x.product_id === window.globalVariables.product.id);
          index >= 0 && getRecentlyViewed.splice(index, 1);
          // End code to remove current product from the recently viewed
          getRecentlyViewed.forEach((reproduct) => {
            if (this.recentlyViewed.length < 4) {
              this.recentlyViewed.push(reproduct);
            }
          });
          // reverse
          this.recentlyViewed.reverse();
          //Add recentlyViewed products data into html
          this.showRecentlyViewedProducts(this.recentlyViewed);
        } else {
            document.querySelector('.section-recently-viewed-products')?.classList.add('d-none');
            modalElementDefined = true;
        }
        // product page
        let productObj = document.querySelector("[data-product-json]");
        if(productObj) {
          if (productObj.innerHTML) {
              productObj = JSON.parse(productObj.innerHTML);
              this.currentProduct = productObj;
              this.currentProductHandle = productObj.handle;
              this.currentVariant = productObj.variants[0];
              this.currentVariantId = productObj.variants[0].id;
              this.addVariantToRecentlyViewed(this.currentProductHandle,this.currentVariantId);
              // filter data
              // exclude the current visited product
              this.recentlyViewed = this.recentlyViewed.filter((item) => {
                return item.id !== this.currentVariantId;
              });
            }
        }
      },
      showRecentlyViewedProducts(productsJSON) {

        let recentlyViewedHTML = '';
        // Start HTML Code. You will need to change this code based on your design requirements
        for (let i=0; i<productsJSON.length; i++) {
           
            var enable_zipcode = false;
            var is_servv = false;
            if (window.globalVariables.enable_zipcode == true && productsJSON[i].tags.includes('available_for_purchase-In Store')) {
                enable_zipcode = true;
            }
            let isSwingMachineAndInstorePurchase = false;
            if (productsJSON[i].tags.includes("sewing-machines") && productsJSON[i].tags.includes('available_for_purchase-In Store')) {
            
                isSwingMachineAndInstorePurchase = true;
                
            }
            let compare_at_price = productsJSON[i].price;
            if (productsJSON[i].compare_at_price != null && productsJSON[i].compare_at_price > productsJSON[i].price) {
                compare_at_price = productsJSON[i].compare_at_price;
            }
            var is_swing_machine = false;
            if (productsJSON[i].tags.includes('sewing-machines')) {
                is_swing_machine = true;
            }
            if(productsJSON[i].vendor.includes('SERVV')) { is_servv = true; }
            var prd_img = productsJSON[i].featured_image;
            
            if(prd_img == null) {
                prd_img = window.globalVariables.no_image;
            }
            recentlyViewedHTML += `
            <div class="swiper-slide">
                <div class="card card-product card-product-style-1 text-start rounded-0 border-0" data-product-grid="${productsJSON[i].id}">
        
                <div class="card-img text-center position-relative">
                        <a href="${productsJSON[i].product_url}" name="${productsJSON[i].product_url}" title="${productsJSON[i].product_url}" aria-label="${productsJSON[i].product_url}" class="d-block product-link">
                            <img srcset="${prd_img ? prd_img : productsJSON[i].product_image}" loading="lazy" class="w-100" data-hoverimage="" width="350" height="350" alt="${productsJSON[i].product_title}" title="${productsJSON[i].product_title}" />
                        </a>
                        <div class="card-footer bg-transparent border-0 p-0 d-md-block d-none">
                            <product-form class="product-form">
                                <form method="post" action="/cart/add" id="product-form-${productsJSON[i].id}" accept-charset="UTF-8" class="mt-4" enctype="multipart/form-data" data-productid="${productsJSON[i].id}" data-product-form="" data-product-id="${productsJSON[i].id}" data-type="add-to-cart-form" data-format="grid">
                                    <input type="hidden" name="form_type" value="product" aria-label="form_type" />
                                    <input type="hidden" name="utf8" value="✓" aria-label="utf8" />
                                    <input type="hidden" name="id" value="${productsJSON[i].id}" aria-label="id" />
                                    <div class="row">
                                        <div class="col-12 d-flex justify-content-between flex-column">
                                            <input type="hidden" name="quantity" value="1" aria-label="quantity" />
                                        </div>
                                    </div>
                                    <noscript>
                                        <div class="row d-none">
                                            <div class="col">
                                                <select name="id" data-productid="${productsJSON[i].id}">
                                                    <option
                                                        data-sku="" data-product-id="${productsJSON[i].id}" data-variant-id="${productsJSON[i].id}"
                                                        value="${productsJSON[i].id}" >
                                                        Default Title - ${Shopify.formatMoney(productsJSON[i].price, window.globalVariables.money_format)}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </noscript>
                                    <div class="row no-gutter">
                                        <div class="col-lg-10 col-md-11 d-flex mx-auto ${is_servv ? 'd-none' : ''} ${isSwingMachineAndInstorePurchase ? 'd-none' : ''} ">
                                        ${enable_zipcode ? `<button type="button" class="btn add-to-cart request-quote mx-auto" data-compare_price="${Shopify.formatMoney(compare_at_price, window.globalVariables.money_format)}" data_swing_machine="${is_swing_machine}" data-product-price="${Shopify.formatMoney(productsJSON[i].price, window.globalVariables.money_format)}" data-product-handle="${productsJSON[i].product_handle}" data-product-title="${productsJSON[i].product_title}" data-pr-id="${productsJSON[i].product_id}" data-quotify data-product-id="${productsJSON[i].product_id}" data-pr-name="${productsJSON[i].product_title}" aria-label="${window.generalStrings.request_quote}">
                                            <span class="add-text">${window.generalStrings.request_quote}</span>
                                        </button>`: ''}
                                            <button class="btn add-to-cart mx-auto ${productsJSON[i].available ? '' : 'disabled-btn'} ${enable_zipcode ? 'd-none' : ''}" type="submit" name="add" aria-label="${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}">
                                                <span class="add-text">${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}</span>
                                                <span class="spinner"></span>
                                            </button>
                                        </div>
                                        <div class="col-lg-10 col-md-11 d-flex mx-auto ${!is_servv ? 'd-none' : ''}">
                                            <a href="${productsJSON[i].product_url}" class="btn add-to-cart mx-auto" aria-label="${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}">
                                                <span class="add-text">${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}</span>
                                                <span class="spinner"></span>
                                            </a>
                                        </div>
                                    </div>
                                </form>
                            </product-form>
                        </div>
                    </div>
                    <div class="card-body px-0">
                        <div class="row no-gutter">
                            <div class="col-12">
                                <p class="card-title">
                                    <a class="product-link text-indigo-dye" role="button" href="${productsJSON[i].product_url}">${productsJSON[i].product_title}</a>
                                </p>
                                <span class="fw-bold" data-currentprice=""> ${enable_zipcode ? '' : Shopify.formatMoney(productsJSON[i].price, window.globalVariables.money_format)}</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer bg-transparent border-0 p-0 d-md-none d-block">
                        <product-form class="product-form">
                            <form method="post" action="/cart/add" id="product-form-${productsJSON[i].id}" accept-charset="UTF-8" class="mt-4" enctype="multipart/form-data" data-productid="${productsJSON[i].id}" data-product-form="" data-product-id="${productsJSON[i].id}" data-type="add-to-cart-form" data-format="grid">
                                <input type="hidden" name="form_type" value="product" aria-label="form_type" />
                                <input type="hidden" name="utf8" value="✓" aria-label="utf8" />
                                <input type="hidden" name="id" value="${productsJSON[i].id}" aria-label="id" />
                                <div class="row">
                                    <div class="col-12 d-flex justify-content-between flex-column">
                                        <input type="hidden" name="quantity" value="1" aria-label="quantity" />
                                    </div>
                                </div>
                                <noscript>
                                    <div class="row d-none">
                                        <div class="col">
                                            <select name="id" data-productid="${productsJSON[i].id}">
                                            
                                                <option
                                                    data-sku="" data-product-id="${productsJSON[i].id}" data-variant-id="${productsJSON[i].id}"
                                                    value="${productsJSON[i].id}" >
                                                    Default Title - ${Shopify.formatMoney(productsJSON[i].price, window.globalVariables.money_format)}
                                                </option>
                                            
                                            </select>
                                        </div>
                                    </div>
                                </noscript>
                                <div class="row no-gutter">

                                    <div class="col-lg-10 col-md-11 d-flex mx-auto ${is_servv ? 'd-none' : ''}">
                                        ${enable_zipcode ? `<button type="button" class="btn add-to-cart request-quote mx-auto" data-compare_price="${Shopify.formatMoney(compare_at_price, window.globalVariables.money_format)}" data_swing_machine="${is_swing_machine}" data-pr-id="${productsJSON[i].product_id}" data-quotify data-product-id="${productsJSON[i].product_id}" data-pr-name="${productsJSON[i].product_title}" data-product-price="${Shopify.formatMoney(productsJSON[i].price, window.globalVariables.money_format)}" data-product-handle="${productsJSON[i].product_handle}" data-product-title="${productsJSON[i].product_title}" aria-label="${window.generalStrings.request_quote}">
                                            <span class="add-text">${window.generalStrings.request_quote}</span>
                                        </button>`: ''}
                                        <button class="btn add-to-cart mx-auto ${productsJSON[i].available ? '' : 'disabled-btn'} ${enable_zipcode ? 'd-none' : ''}" type="submit" name="add" aria-label="${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}">
                                            <span class="add-text">${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}</span>
                                            <span class="spinner"></span>
                                        </button>
                                    </div>
                                    <div class="col-lg-10 col-md-11 d-flex mx-auto ${!is_servv ? 'd-none' : ''} ${isSwingMachineAndInstorePurchase ? 'd-none' : ''}">
                                        <a href="${productsJSON[i].product_url}" class="btn add-to-cart mx-auto" aria-label="${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}">
                                            <span class="add-text">${productsJSON[i].available ? window.variantStrings.addToCart : window.variantStrings.out_of_stock}</span>
                                            <span class="spinner"></span>
                                        </a>
                                    </div>
                                </div>
                            </form>
                        </product-form>
                    </div>
                </div>
            </div>
            `;
        }
        if(document.querySelector("[data-recentlyViewed]")) document.querySelector("[data-recentlyViewed]").innerHTML = recentlyViewedHTML;
        // End HTML Code. You will need to change this code based on your design requirements
        setTimeout(() => {
            window.reExecuteOpener();
            var allWishlistSelector = document.querySelectorAll('[data-product-grid]');
            if (allWishlistSelector.length > 0) {
                allWishlistSelector.forEach(item => {
                    var pId = item.getAttribute('data-product-grid');
                    window._swat.initializeActionButtons(`[data-product-grid="${pId}"]`, '[data-swaction]');
                })
            }
        }, 1000);
      },
      addVariantToRecentlyViewed(productHandle, variantId) {
        const checkindex = this.recentlyViewed.findIndex((x) => {
          return x.id === variantId;
        });
        if (checkindex === -1) {
          const tempVariant = this.currentVariant;
          // add additional properties to the object
          tempVariant.product_id = this.currentProduct.id;
          tempVariant.product_title = this.currentProduct.title;
          tempVariant.product_handle = productHandle;
          tempVariant.product_image = this.currentProduct.images[0];
          tempVariant.product_url = "/products/" + productHandle;
          tempVariant.tags = this.currentProduct.tags;
          tempVariant.vendor = this.currentProduct.vendor;
          tempVariant.options_with_values = this.currentProduct.options_with_values;
          if (tempVariant.option1 === "Default Title" || tempVariant.featured_image === null) {
              tempVariant.featured_image = this.currentProduct.featured_image;
          } else {
              tempVariant.featured_image =
              this.currentVariant.featured_image.src || "";
          }
          this.recentlyViewed.length > 3 && this.recentlyViewed.shift();
          this.recentlyViewed.push(tempVariant);
          localStorage.setItem(
            "user_recently_viewed",
            JSON.stringify(this.recentlyViewed)
          );
        }
      }
}

function initRecentlyViewedProducts() {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    window.recentlyView.getRecentlyViewed();
  } else {
    setTimeout(initRecentlyViewedProducts, 0);
  }
}

if (document.readyState === 'complete') {
  initRecentlyViewedProducts();
} else {
  document.addEventListener('DOMContentLoaded', initRecentlyViewedProducts);
}